/*
 * @Author: linsy 
 * @Date: 2018-04-16 12:12:03 
 * @Description: logisticsService
 * @Last Modified by: senylin
 * @Last Modified time: 2018-12-26 14:19:16
 */

import { MutationTree, ActionTree, GetterTree } from '@shield/vuepack';

class State {}

const mutations: MutationTree<State> = {};

const actions = {};

const getters = {
  applyList: (state: any, getters: any, rootState: any, rootGetter: any) => {
    // const api: any = rootState.api
    // console.log(123213,rootState.api)
    return rootState.api.vatRegister ? rootState.api.vatRegister.getAppliesList: []
  },
  nations: (state: any, getters: any, rootState: any, rootGetter: any) => {
    // const api: any = rootState.api
    return rootState.api.vatRegister.getRegisterNations
      ? rootState.api.vatRegister.getRegisterNations
      : [];
  },
  poundage: (state: any, getters: any, rootState: any, rootGetter: any) => {
    // const api: any = rootState.api
    return rootState.api.vatRegister.getRegisterPoundage
      ? rootState.api.vatRegister.getRegisterPoundage
      : [];
  },
  applyDetail: (state: any, getters: any, rootState: any, rootGetter: any) => {
    // const api: any = rootState.api
    return rootState.api.vatRegister.getAppliesDetail
      ? rootState.api.vatRegister.getAppliesDetail
      : [];
  },
  storeList: (state: any, getters: any, rootState: any, rootGetter: any) => {
    // const api: any = rootState.api
    // console.log(123213,rootState.api)
    return rootState.api.vatRegister ? rootState.api.vatRegister.getStore: []
  }
};

export default {
  namespaced: true,
  state: new State(),
  mutations,
  actions,
  getters
};
